<template>
  <Carousel :items-to-show="1">
    <Slide v-for="(img, i) in images" :key="i">
      <img :src="img" style="width: 300px; max-width: 100%; display: inline" />
    </Slide>
    <template #addons>
      <Navigation v-if="images.length > 1" />
    </template>
  </Carousel>
</template>

<style>
@import 'vue3-carousel/dist/carousel.css';

.carousel__slide {
  position: relative;
  color: #fff;
  font-family: Arial;
  font-size: 24px;
  text-align: center;
}
</style>

<script>
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
  name: 'ImageModal',
  props: {
    imageUrl: String,
    allImages: Array,
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      images: this.allImages,
    }
  },
}
</script>
